import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-app/src/components/layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
